import { render, staticRenderFns } from "./AIAgent.VoiceTraining.vue?vue&type=template&id=64737258&lang=pug"
import script from "./AIAgent.VoiceTraining.vue?vue&type=script&lang=js"
export * from "./AIAgent.VoiceTraining.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.VoiceTraining.vue?vue&type=style&index=0&id=64737258&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports